export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{ 
		name: 'label',
		label: 'Label',
		selector: '& .baseLabel'
	},
	{
		name: 'input',
		label: 'Input',
		selector: '& .input'
	},
	{
		name: 'button',
		label: 'Button',
		selector: '& .baseButton'
	},
	{
		name: 'billingFields',
		label: 'Billing Fields',
		selector: '& .checkout-billing-fields'
	},
	{
		name: 'shippingFields',
		label: 'Shipping Fields',
		selector: '& .checkout-shipping-fields'
	},
	{
		name: 'pricingOptions',
		label: 'Pricing Options',
		selector: '& .checkout-pricing-options'
	},
	{
		name: 'paymentSummary',
		label: 'Payment Summary',
		selector: '& .checkout-payment-summary'
	},
	{
		name: 'paymentOptions',
		label: 'Payment Options',
		selector: '& .checkout-payment-options'
	},
	{
		name: 'coupon',
		label: 'Coupon',
		selector: '& .checkout-coupon'
	}
]